export const exchangeRates2019 = {
  disclaimer: 'Usage subject to terms: https://openexchangerates.org/terms',
  license: 'https://openexchangerates.org/license',
  timestamp: 1548622804,
  base: 'USD',
  rates: {
    AED: 3.673022,
    AFN: 75.5405,
    ALL: 109.083922,
    AMD: 483.986033,
    ANG: 1.776505,
    AOA: 310.806,
    ARS: 37.187986,
    AUD: 1.39475,
    AWG: 1.801503,
    AZN: 1.7025,
    BAM: 1.715548,
    BBD: 2,
    BDT: 83.367136,
    BGN: 1.715755,
    BHD: 0.375248,
    BIF: 1786.849543,
    BMD: 1,
    BND: 1.349849,
    BOB: 6.877125,
    BRL: 3.754752,
    BSD: 1,
    BTC: 0.000280716173,
    BTN: 70.622403,
    BWP: 10.416362,
    BYN: 2.145797,
    BZD: 2.006141,
    CAD: 1.322209,
    CDF: 1637.651735,
    CHF: 0.993062,
    CLF: 0.024214,
    CLP: 666.533387,
    CNH: 6.754205,
    CNY: 6.74865,
    COP: 3154.63584,
    CRC: 601.135114,
    CUC: 1,
    CUP: 25.75,
    CVE: 96.95,
    CZK: 22.504033,
    DJF: 178.05,
    DKK: 6.546921,
    DOP: 50.329404,
    DZD: 118.61,
    EGP: 17.905,
    ERN: 14.997622,
    ETB: 28.254838,
    EUR: 0.876839,
    FJD: 2.126405,
    FKP: 0.75861,
    GBP: 0.75861,
    GEL: 2.66375,
    GGP: 0.75861,
    GHS: 4.89088,
    GIP: 0.75861,
    GMD: 49.54,
    GNF: 9074.664955,
    GTQ: 7.689831,
    GYD: 207.831342,
    HKD: 7.845345,
    HNL: 24.277605,
    HRK: 6.516891,
    HTG: 78.188127,
    HUF: 278.585,
    IDR: 14012.55,
    ILS: 3.66835,
    IMP: 0.75861,
    INR: 70.979,
    IQD: 1187.587929,
    IRR: 42105,
    ISK: 119.030177,
    JEP: 0.75861,
    JMD: 131.539095,
    JOD: 0.709604,
    JPY: 109.514,
    KES: 100.8555,
    KGS: 68.698418,
    KHR: 3994.899556,
    KMF: 431.372243,
    KPW: 900,
    KRW: 1113.55,
    KWD: 0.30333,
    KYD: 0.829428,
    KZT: 377.679118,
    LAK: 8524.277423,
    LBP: 1500.800714,
    LKR: 180.790404,
    LRD: 160.749677,
    LSL: 13.620025,
    LYD: 1.380016,
    MAD: 9.555003,
    MDL: 17.038822,
    MGA: 3530.523359,
    MKD: 54.18,
    MMK: 1518.28022,
    MNT: 2453.75,
    MOP: 8.0431,
    MRO: 357,
    MRU: 36.4,
    MUR: 34.36725,
    MVR: 15.499988,
    MWK: 726.234125,
    MXN: 19.01409,
    MYR: 4.124478,
    MZN: 61.900268,
    NAD: 13.630012,
    NGN: 360.281445,
    NIO: 32.415284,
    NOK: 8.514268,
    NPR: 112.994938,
    NZD: 1.464472,
    OMR: 0.383147,
    PAB: 1,
    PEN: 3.331256,
    PGK: 3.35319,
    PHP: 52.581774,
    PKR: 139.214173,
    PLN: 3.761,
    PYG: 6013.426988,
    QAR: 3.6237,
    RON: 4.180701,
    RSD: 103.78,
    RUB: 65.9835,
    RWF: 891.726425,
    SAR: 3.7506,
    SBD: 8.138694,
    SCR: 13.65,
    SDG: 47.37466,
    SEK: 9.04891,
    SGD: 1.353223,
    SHP: 0.75861,
    SLL: 8390,
    SOS: 575.762636,
    SRD: 7.458,
    SSP: 130.2634,
    STD: 21050.59961,
    STN: 21.58,
    SVC: 8.709369,
    SYP: 514.993276,
    SZL: 13.62212,
    THB: 31.5515,
    TJS: 9.389791,
    TMT: 3.499986,
    TND: 3.020005,
    TOP: 2.263823,
    TRY: 5.280419,
    TTD: 6.757898,
    TWD: 30.647811,
    TZS: 2302.00697,
    UAH: 27.648979,
    UGX: 3657.542563,
    USD: 1,
    UYU: 32.61281,
    UZS: 8327.574545,
    VEF: 248487.642241,
    VES: 1569.627629,
    VND: 23074.980541,
    VUV: 111.190891,
    WST: 2.623587,
    XAF: 575.168852,
    XAG: 0.06350225,
    XAU: 0.00076791,
    XCD: 2.70255,
    XDR: 0.716292,
    XOF: 575.168852,
    XPD: 0.00073497,
    XPF: 104.634757,
    XPT: 0.00122113,
    YER: 250.300787,
    ZAR: 13.640912,
    ZMW: 11.89856,
    ZWL: 322.355011,
  },
};
